import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useValidateCredentialsMutation, useConnectMutation, useTriggerSyncMutation } from '../hooks/useServiceTradeMutations';
import { CredentialsStep, PreviewStep, SuccessStep } from './WizardSteps';
export default function ConnectionWizard({ onConnectionComplete, onCancel }) {
    const [step, setStep] = useState('credentials');
    const [error, setError] = useState(null);
    // Single form instance for entire wizard
    const { control, handleSubmit, watch, setValue, formState } = useForm({
        mode: 'onChange',
        defaultValues: {
            username: '',
            password: '',
            selectedOfficeIds: []
        }
    });
    // Mutations
    const validateMutation = useValidateCredentialsMutation();
    const connectMutation = useConnectMutation();
    const syncMutation = useTriggerSyncMutation();
    const handleCredentialsSubmit = () => {
        setError(null);
        const data = watch();
        validateMutation.mutate({ username: data.username, password: data.password }, {
            onSuccess: (response) => {
                if (response.success && response.preview && response.auth_token) {
                    // Store API response data in form
                    setValue('authToken', response.auth_token);
                    setValue('preview', response.preview);
                    setStep('preview');
                }
                else {
                    setError(response.error || 'Failed to validate credentials');
                }
            },
            onError: (err) => {
                setError(err.message);
            }
        });
    };
    const handlePreviewSubmit = () => {
        const data = watch();
        if (!data.preview) {
            setError('Preview data missing, please complete the form');
            return;
        }
        if (!data.authToken) {
            setError('Authentication token missing, please re-validate credentials');
            return;
        }
        setError(null);
        connectMutation.mutate({
            username: data.username,
            password: data.password,
            vendorId: data.preview.vendor_id,
            officeIds: data.selectedOfficeIds,
            authToken: data.authToken
        }, {
            onSuccess: (response) => {
                if (response.success) {
                    setStep('success');
                }
                else {
                    setError(response.error || 'Failed to connect');
                }
            },
            onError: (err) => {
                setError(err.message);
            }
        });
    };
    const handleStartSync = () => {
        const data = watch();
        syncMutation.mutate(data.selectedOfficeIds, {
            onSuccess: () => {
                onConnectionComplete();
            },
            onError: (err) => {
                setError(err.message);
            }
        });
    };
    const handleBack = () => {
        setError(null);
        setStep('credentials');
    };
    const isLoading = validateMutation.isLoading || connectMutation.isLoading || syncMutation.isLoading;
    const preview = watch('preview');
    if (step === 'credentials') {
        return (React.createElement(CredentialsStep, { control: control, onNext: handleCredentialsSubmit, onCancel: onCancel, isLoading: isLoading, isValid: formState.isValid, error: error }));
    }
    if (step === 'preview' && preview) {
        return (React.createElement(PreviewStep, { control: control, preview: preview, onNext: handlePreviewSubmit, onBack: handleBack, isLoading: isLoading, error: error }));
    }
    if (step === 'success') {
        return (React.createElement(SuccessStep, { onStartSync: handleStartSync, onSkipSync: onConnectionComplete, isLoading: isLoading, error: error }));
    }
    return React.createElement(React.Fragment, null);
}
